import React, { Component } from 'react'

class SocialShare extends Component {
  constructor(props) {
    super(props)
    this.openShareWindow = this.openShareWindow.bind(this)
  }

  openShareWindow(url, title = 'Share', width = 600, height = 400) {
    const left = (window.innerWidth - width) / 2
    const top = (window.innerHeight - height) / 2

    window.open(
      url,
      title,
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    )
  }

  getShareUrl() {
    return this.props.url || window.location.href
  }

  getShareText() {
    return this.props.text || this.props.subject || 'Check this out!'
  }

  handleEmailShare = () => {
    const url = this.getShareUrl()
    const subject = encodeURIComponent(this.props.subject || 'Check this out!')
    const body = encodeURIComponent(`${this.getShareText()}\n\n${url}`)

    window.location.href = `mailto:?subject=${subject}&body=${body}`
  }

  handleFacebookShare = () => {
    const url = this.getShareUrl()

    // Use the simple and most reliable Facebook sharer
    const encodedUrl = encodeURIComponent(url)
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`

    this.openShareWindow(shareUrl, 'Facebook Share', 626, 436)
  }

  handleSMSShare = () => {
    const text = encodeURIComponent(`${this.getShareText()} ${this.getShareUrl()}`)

    // Check if it's iOS or Android for different SMS protocols
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    const separator = isIOS ? '&' : '?'

    window.location.href = `sms:${separator}body=${text}`
  }

  handleTelegramShare = () => {
    const url = encodeURIComponent(this.getShareUrl())
    const text = encodeURIComponent(this.getShareText())
    const shareUrl = `https://t.me/share/url?url=${url}&text=${text}`
    this.openShareWindow(shareUrl, 'Telegram Share')
  }

  handleMessengerShare = () => {
    const url = encodeURIComponent(this.getShareUrl())
    const shareUrl = `https://www.facebook.com/dialog/send?link=${url}&app_id=${this.props.facebookAppId || ''}`
    this.openShareWindow(shareUrl, 'Messenger Share')
  }

  handleWhatsAppShare = () => {
    const text = encodeURIComponent(`${this.getShareText()} ${this.getShareUrl()}`)
    const shareUrl = `https://wa.me/?text=${text}`
    this.openShareWindow(shareUrl, 'WhatsApp Share')
  }

  getIcon(platform) {
    const icons = {
      email: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
      ),
      facebook: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      sms: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>
        </svg>
      ),
      telegram: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
        </svg>
      ),
      messenger: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0C5.373 0 0 4.975 0 11.111c0 3.497 1.745 6.616 4.472 8.652V24l4.086-2.242c1.09.301 2.246.464 3.442.464 6.627 0 12-4.974 12-11.111C24 4.975 18.627 0 12 0zm1.193 14.963l-3.056-3.259-5.963 3.259L10.733 8.2l3.13 3.259L19.794 8.2l-6.601 6.763z"/>
        </svg>
      ),
      whatsapp: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
        </svg>
      )
    }

    return icons[platform] || null
  }

  renderShareButton(platform, handler, icon, label) {
    const { className = '', iconClassName = '' } = this.props

    return (
      <button
        key={platform}
        onClick={handler}
        className={`social-share-button social-share-button--${platform} ${className}`}
        title={`Share via ${label}`}
        aria-label={`Share via ${label}`}
      >
        <span className={`social-share-icon ${iconClassName}`}>
          {this.getIcon(platform)}
        </span>
        {this.props.showLabels && <span className="social-share-label">{label}</span>}
      </button>
    )
  }

  render() {
    const { platforms = ['email', 'facebook', 'sms', 'telegram', 'messenger', 'whatsapp'] } = this.props

    const shareHandlers = {
      email: { handler: this.handleEmailShare, label: 'Email' },
      facebook: { handler: this.handleFacebookShare, label: 'Facebook' },
      sms: { handler: this.handleSMSShare, label: 'SMS' },
      telegram: { handler: this.handleTelegramShare, label: 'Telegram' },
      messenger: { handler: this.handleMessengerShare, label: 'Messenger' },
      whatsapp: { handler: this.handleWhatsAppShare, label: 'WhatsApp' }
    }

    return (
      <div className={`social-share-container ${this.props.containerClassName || ''}`}>
        {platforms.map(platform => {
          const config = shareHandlers[platform]
          if (!config) return null

          return this.renderShareButton(
            platform,
            config.handler,
            null,
            config.label
          )
        })}
      </div>
    )
  }
}

export default SocialShare
